module.exports = __webpack_public_path__ + "static/img/shj-tl.715328c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shj-tl.png
// module id = a4vw
// module chunks = 1